import { createEnumFromArray } from '@cloud-wave/neon-common-lib';

export const iqResponseStates = ['THINKING', 'RETHINKING', 'STANDBY', 'ERROR'] as const;
export const IQResponseState = createEnumFromArray(iqResponseStates);

export type TIQState = keyof typeof IQResponseState;
